import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  atnd(parameters={}) {
    return core.call({
      url: '/api/v1/external/eduqr/atnd',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  },
  list(parameters={}) {
    return core.call({
      url: '/api/v1/external/eduqr/list',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'N'
      }    
    }); 
  }
}
